module.exports = __webpack_public_path__ + "static/media/Mail.svg";